import log from 'loglevel';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from 'constants/translations';

// Instructions on how to use translations can be found here:
// https://react.i18next.com/guides/quick-start


const getBrowserLanguage = () => {
  const englishLanguages = [
    'en',
    'en-US',
    'en-AU',
    'en-CA',
    'en-IN',
    'en-NZ',
    'en-ZA',
    'en-GB-oxendict',
    'en-GB',
  ];
  const frenchLanguages = ['fr-CA', 'fr-FR', 'fr'];

  if (englishLanguages.includes(navigator.language)) {
    return 'E';
  }

  if (frenchLanguages.includes(navigator.language)) {
    return 'F';
  }

  return 'E';
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getBrowserLanguage(),

    keySeparator: '.',

    interpolation: {
      escapeValue: false, // react is already safe from xss
    },

    parseMissingKeyHandler: (key) => {
      if (process.env.NODE_ENV !== 'production') {
        log.error(`Failed to lookup translation key: '${key}'`);
      }
      return key;
    },

    missingKeyHandler: (lng, ns, key) => {
      if (process.env.NODE_ENV !== 'production') {
        log.error(
          `Failed to lookup key '${key}' in namespace '${ns}' for language '${lng}'`,
        );
      }
    },
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js